import React, { useEffect, useState, useRef } from "react";
import {useTranslate} from "../useTranslate";

export default function Countdown({ targetDate, onComplete, format = "label" }) {
    const translate = useTranslate();
    const parseTarget = (t) => (t instanceof Date ? t : new Date(t));

    const target = useRef(parseTarget(targetDate));
    const [timeLeft, setTimeLeft] = useState(() =>
        target.current.getTime() - Date.now()
    );
    const completedRef = useRef(false);

    useEffect(() => {
        target.current = parseTarget(targetDate);
        completedRef.current = false;
        setTimeLeft(target.current.getTime() - Date.now());
    }, [targetDate]);

    useEffect(() => {
        const tick = () => {
            const diff = target.current.getTime() - Date.now();
            setTimeLeft(diff > 0 ? diff : 0);
        };
        const interval = setInterval(tick, 1000);
        tick();
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (timeLeft === 0 && !completedRef.current) {
            completedRef.current = true;
            if (typeof onComplete === "function") onComplete();
        }
    }, [timeLeft, onComplete]);

    const totalSeconds = Math.floor(timeLeft / 1000);
    const seconds = totalSeconds % 60;
    const minutes = Math.floor(totalSeconds / 60) % 60;
    const hours = Math.floor(totalSeconds / 3600) % 24;
    const days = Math.floor(totalSeconds / 86400);

    const pad = (n) => String(n).padStart(2, "0");

    let output;

    if (format === "datetime") {
        // build [days, hh:mm:ss] but remove zero parts
        const parts = [];
        if (days > 0) parts.push(days + translate("days"));
        if (hours > 0 || parts.length) parts.push(pad(hours)); // only add hours if nonzero OR after days
        if (minutes > 0 || parts.length) parts.push(pad(minutes));
        parts.push(pad(seconds)); // always show seconds
        output = parts.join(parts.length > 1 && parts[0].includes(translate("days")) ? " " : ":");
    } else {
        // labeled format - skip any zero unit
        const parts = [];
        if (days > 0) parts.push(days + translate("days"));
        if (hours > 0) parts.push(hours + translate("hours"));
        if (minutes > 0) parts.push(minutes + translate("minutes"));
        if (seconds > 0 || parts.length === 0) parts.push(seconds + translate("seconds")); // always show seconds if everything else is 0
        output = parts.join(" ");
    }

    return output;
}

